<template>
  <div
    class="bg-white relative px-4 pb-4 pt-2 rounded-lg shadow-md flex flex-col h-full"
    :class="{ 'justify-between': !usingNoData }"
    @mouseenter="showClear = true" @mouseleave="showClear = false"
  >
    <div>
        <div class="font-bold text-lg flex gap-2 items-center">
            {{ props.title }}
            <LoadingSpinner :size="20" v-if="props.loading"/>
        </div>

        <div v-if="props.subtitle && !usingNoData" class="font-medium text-sm flex gap-2">
            {{ props.subtitle }}
            <transition
                enter-from-class="opacity-0"
                leave-to-class="opacity-0"
                enter-active-class="transition"
                leave-active-class="transition"
            >
                <XIcon v-show="showClear && !blockClear" class="w-3 cursor-pointer" @click="() => { emit('clearFilter'); showClear = false }" />
            </transition>
        </div>
        <div v-else class="pb-5" />
    </div>

    <Pie
        v-if="!usingNoData"
        class="flex justify-center"
        :chartData="props.data"
        :height="200"
        :chartOptions="{
            maintainAspectRatio: false,
            plugins: {
                tooltip: {
                    callbacks: {
                        label: (context) => context.label + ' : ' + context.formattedValue + '%'
                    }
                }
            }
        }"
    />

    <div v-else class="-mt-5">
        No data for {{ props.subtitle }}
    </div>

    <div class="flex flex-col items-center gap-2" v-if="!usingNoData && !usingHideLegend">
        <div class="w-fit flex flex-col gap-2">
            <div class="flex gap-2">
                <div class="h-4 w-8 rounded-lg registered"></div>
                <span class="text-xs text-gray-500">Registered</span>
            </div>

            <div class="flex gap-2">
                <div class="h-4 w-8 rounded-lg sold"></div>
                <span class="text-xs text-gray-500">Unregistered</span>
            </div>
        </div>

    </div>
  </div>
</template>

<script setup>
    import { defineProps, ref, defineEmits, computed } from 'vue'
    import { Chart as ChartJS, ArcElement, Tooltip } from 'chart.js'
    import { Pie } from 'vue-chartjs'
    import LoadingSpinner from './LoadingSpinner.vue';
    import { XIcon} from '@heroicons/vue/solid'

    ChartJS.register(ArcElement, Tooltip)

    const props = defineProps(['title', 'data', 'legend', 'loading', 'subtitle', 'blockClear', 'noData', 'hideLegend'])
    const emit = defineEmits(['clearFilter'])

    const blockClear = ref(props.blockClear)
    const showClear = ref(false)
    const usingNoData = computed(() => props.noData)
    const usingHideLegend = computed(() => props.hideLegend)
</script>

<style scoped>
.sold {
    background-color: #009DDA;
}

.registered {
    background-color: #3b82f6;
}
</style>